import React, { useEffect, useState } from 'react';
import { ContenedorAlerta } from '../styles/components/alert.styles';

function getScrollBarWidth () { 
    var inner = document.createElement('p'); 
    inner.style.width = "100%"; 
    inner.style.height = "200px"; 
  
    var outer = document.createElement('div'); 
    outer.style.position = "absolute"; 
    outer.style.top = "0px"; 
    outer.style.left = "0px"; 
    outer.style.visibility = "hidden"; 
    outer.style.width = "200px"; 
    outer.style.height = "150px"; 
    outer.style.overflow = "hidden"; 
    outer.appendChild (inner); 
  
    document.body.appendChild (outer); 
    var w1 = inner.offsetWidth; 
    outer.style.overflow = 'scroll'; 
    var w2 = inner.offsetWidth; 
    if (w1 === w2) w2 = outer.clientWidth; 
  
    document.body.removeChild (outer); 

    let result = w1 -w2
  
    return result; 
};

const Alerta = ({tipo, mensaje, estadoAlerta, cambiarEstadoAlerta}) => {

    // Creamos hook de useState para conseguir el ancho del scrollbar
    const [ scrollBarWidth, setScrollBarWidth ] = useState(0);

    setTimeout(() => {
        let width = getScrollBarWidth();
        setScrollBarWidth(width);
        if(scrollBarWidth) {
            return '';
        }
    }, 100);
    
    // Creamos un hook de useEffect
    useEffect(() => {
        let tiempo;

        if(estadoAlerta === true) {
            tiempo = setTimeout(() => {
                cambiarEstadoAlerta(false);
            }, 4000);
        }

        // Pasamos una función de limpieza. Esta función se ejecuta si el componente se desmonta.
        // Lo que hacemos es limpiar el tiempo para que no intente cambiar el estado si el componente no está en pantalla.
        // Es importante para poder cambiar components en pantalla sin errores.
        return(() => clearTimeout(tiempo));
    }, [estadoAlerta, cambiarEstadoAlerta]);

    return (
        <>
            {/* Si estado alerta es verdadero, se muestra, si no no */}
            {estadoAlerta && 
                <ContenedorAlerta tipo={tipo}>
                    <p> { mensaje } </p>
                </ContenedorAlerta>
            }
        </>
    );
}
 
export default Alerta;